module.exports = __webpack_public_path__ + "static/media/receipt-search-light.c266893a.svg";